import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09b3eab4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "count-down" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_4 = { class: "count-down-counter" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "天", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ":", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ":", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ".", -1))

import {onMounted, onUnmounted, reactive} from 'vue'
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'CountDownBasicStyle',
  props: {
    end: {}
  },
  setup(__props: any) {

const props = __props
const info = reactive({day: 0, hour: 0, min: 0, sec: 0, ms: 0, timer: 0})

onMounted(() => {
  info.timer = window.setInterval(() => {
    const ts = dayjs.duration(props.end.valueOf() - Date.now().valueOf())
    info.day = ts.days() > 0 ? ts.days() : 0
    info.hour = ts.hours() > 0 ? ts.hours() : 0
    info.min = ts.minutes() > 0 ? ts.minutes() : 0
    info.sec = ts.seconds() > 0 ? ts.seconds() : 0
    info.ms = Math.floor(ts.milliseconds() / 100)
    info.ms = info.ms > 0 ? info.ms : 0
  }, 100)
})

onUnmounted(() => {
  window.clearInterval(info.timer)
})

return (_ctx: any,_cache: any) => {
  const _component_a_flex = _resolveComponent("a-flex")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_flex, {
      class: "count-down-tip",
      align: "center",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" 活动结束倒计时 "),
        _hoisted_3
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", null, _toDisplayString(info.day), 1),
      _hoisted_5,
      _createElementVNode("span", null, _toDisplayString(info.hour), 1),
      _hoisted_6,
      _createElementVNode("span", null, _toDisplayString(info.min), 1),
      _hoisted_7,
      _createElementVNode("span", null, _toDisplayString(info.sec), 1),
      _hoisted_8,
      _createElementVNode("span", null, _toDisplayString(info.ms), 1)
    ])
  ]))
}
}

})